import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const GenderIcon = styled(FontAwesomeIcon)`
  color: ${(props) => props.theme.color.blue.default};
  margin-right: 5px;
`;
